import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { useNavigate } from 'react-router-dom';
import leftarrow from '../../../safreeimg/left-arrow.png';
import addbtn from '../../../safreeimg/addbtn.png';
import { Link } from 'react-router-dom';


const OrgSubGroupViewDetails = () => {
    const [organisations, setOrganisations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupName, setGroupName] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({
        subGroupId: "",
        name: "",
        description: "",
    });

    const rowsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrganisations = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found');
                    setLoading(false);
                    return;
                }

                const hash = window.location.hash.substring(1); // Get full hash part after '#'
                if (!hash) {
                    setError('No ID found in the URL hash');
                    setLoading(false);
                    return;
                }

                // Extract group ID and group name from the URL hash
                const parts = hash.split('#');
                const groupId = parts[0]; // First part is the group ID
                const groupName = parts[1]; // Second part is the group name

                console.log('Extracted Group ID:', groupId);
                console.log('Extracted Group Name:', groupName);

                if (groupName) {
                    setGroupName(groupName); // Set the group name state
                } else {
                    setError('Group name is missing in the URL');
                    setLoading(false);
                    return;
                }

                const response = await axios.get(
                    `https://api.safree.org/api-v2022/organization/auth/v1/sub-groups-of-group/${groupId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                console.log('API Response:', response);

                if (response.data && Array.isArray(response.data.data)) {
                    setOrganisations(response.data.data);
                } else {
                    setError('Invalid data format from API');
                }
            } catch (err) {
                console.error('Error fetching organisations:', err);
                setError('An error occurred while fetching organisations: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchOrganisations();
    }, []);

    const totalPages = Math.ceil(organisations.length / rowsPerPage);
    const currentRows = organisations.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleViewOrganizationSubGroupsViewdetailsView = (id) => {
        navigate(`../orgSubGroupsViewDetails/#${id}`);
    };

    if (loading) return <div className="loading"><img src={Loader} alt="Loading" /></div>;

    if (error) return <div>Error: {error}</div>;

    const handleBackClick = () => {
        navigate(-1);
    };


    const handleEditGroup = (organisation) => {
        setFormData({
            subGroupId: organisation.subGroupId || "",
            name: organisation.name || "",
            description: organisation.description || "",
        });
        setShowForm(true);
    };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                alert("No authentication token found");
                return;
            }

            await axios.post(
                "https://api.safree.org/api-v2022/organization/auth/v1/edit-sub-group",
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            alert("Sub-group updated successfully!");
            setShowForm(false);
            window.location.reload(); // Reload to fetch updated data
        } catch (err) {
            alert("Failed to update sub-group: " + err.message);
        }
    };

    const handleDeleteSubGroup = async (subGroupId) => {
        console.log('Attempting to delete Subgroup with ID:', subGroupId);  // Log groupId

        const confirmation = window.confirm('Are you sure you want to delete this SubGroup?');
        console.log('User confirmation:', confirmation);  // Log confirmation result

        if (!confirmation) return;

        try {
            const token = localStorage.getItem('token');
            console.log('Retrieved token:', token);  // Log the token

            if (!token) {
                alert('Authentication token is missing. Please log in again.');
                return;
            }

            setLoading(true);

            const response = await axios.delete(
                `https://api.safree.org/api-v2022/organization/auth/v1/delete-sub-group/${subGroupId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log('API Response:', response.data);  // Log the API response

            if (response.data.success) {
                // Remove the deleted sub-group from the organisations state
                setOrganisations(organisations.filter(org => org.subGroupId !== subGroupId));
                alert('SubGroup deleted successfully.');
            } else {
                alert('Failed to delete the SubGroup. Please try again.');
                console.log('Failed to delete Subgroup:', response.data);  // Log failure response
            }
        } catch (err) {
            console.error('Error deleting Subgroup:', err);
            alert(`An error occurred while deleting the user: ${err.message}`);
            console.error('Error details:', err);  // Log detailed error
        } finally {
            setLoading(false);
            console.log('Loading state set to false');  // Log when loading state is set to false
        }
    };

    if (loading)
        return (
            <div className="loading">
                <img src={Loader} alt="Loading" />
            </div>
        );

    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container user-management">
            {/* Header Section */}
            <div className="row header">
                <div className="col-md-6">
                    <p className="sub-heading">
                        <img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" />  Sub Group of <strong>{groupName}</strong>
                    </p>
                </div>
                <div className="col-md-6 hedrcol2">
                    <h3 style={{ cursor: 'pointer' }}>
                        <Link to={`/admin2/orgGroupManagement/orgSubGroupViewDetails/orgAddNewSubGroup#${window.location.hash.substring(1)}`}>
                            Add New Sub Group
                        </Link> <img src={addbtn} alt="" />
                    </h3>
                </div>
            </div>
            <div className="content-wrapper">
                {/* Table Section */}
                <div className="table-container">
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Members</th>
                                <th>Edit SubGroup</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((organisation, index) => (
                                <tr key={organisation._id}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td>{organisation.name}</td>
                                    <td>{organisation.description}</td>
                                    <td>
                                        <button
                                            className="btn btn-view"
                                            onClick={() => handleViewOrganizationSubGroupsViewdetailsView(organisation.subGroupId)}
                                        >
                                            View Details
                                        </button>
                                    </td>
                                    <td>
                                        <button className="btn btn-view" onClick={() => handleEditGroup(organisation)}>
                                            Edit
                                        </button>
                                    </td>
                                    <td>
                                        <button className="btn btn-view" onClick={() => handleDeleteSubGroup(organisation.subGroupId)}>
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Pagination Section */}
                    <div className="pagination-container">
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('prev')}
                            disabled={currentPage === 1}
                        >
                            &laquo; Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </button>
                        ))}
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('next')}
                            disabled={currentPage === totalPages}
                        >
                            Next &raquo;
                        </button>
                    </div>
                </div>
            </div>
            {showForm && (
                <div className="side-form show">
                    <form onSubmit={handleSubmit}>
                        <h3>Edit Group</h3>
                        <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
                        <textarea name="description" value={formData.description} onChange={handleInputChange} required rows="5"></textarea>
                        <button type="submit" className="btn-save">Save Details</button>
                        <button type="button" className="btn-cancel" onClick={() => setShowForm(false)}>Cancel</button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default OrgSubGroupViewDetails;
